var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFactsheet = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 61,
  viewBox: "0 0 60 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M45 38.103C40.8579 38.103 37.5 41.4609 37.5 45.603C37.5 49.7452 40.8579 53.103 45 53.103C49.1421 53.103 52.5 49.7452 52.5 45.603C52.5 41.4609 49.1421 38.103 45 38.103ZM45 38.103V20.603C45 19.2769 44.4732 18.0052 43.5355 17.0675C42.5978 16.1298 41.3261 15.603 40 15.603H32.5M15 23.103C19.1421 23.103 22.5 19.7452 22.5 15.603C22.5 11.4609 19.1421 8.10303 15 8.10303C10.8579 8.10303 7.5 11.4609 7.5 15.603C7.5 19.7452 10.8579 23.103 15 23.103ZM15 23.103V37.478",
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15.603,
  r: 1.875,
  fill: "#30343C"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30.603,
  r: 1.875,
  fill: "#30343C"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 45.603,
  r: 1.875,
  fill: "#30343C"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45.603,
  r: 1.875,
  fill: "#30343C"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.6875,
  cy: 45.9155,
  r: 7.8125,
  stroke: "#4585FF",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconFactsheet;